var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',[_c('button',{staticClass:"btn btn-default text-uppercase w-100",on:{"click":function($event){$event.preventDefault();return _vm.call.apply(null, arguments)}}},[_c('i',{staticClass:"la la-bullhorn"}),_vm._v(" Panggil ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }